import { Component, ViewChild, OnInit } from '@angular/core';
import { BookingStepService } from '../../services/booking-step.service';
import { BookingOrderService } from '../../services/booking-order.service';
import { Router } from '@angular/router';
import { ShopSettingsService } from '../../../general/services/shop-settings.service';
import { NavigationService } from '../../services/navigation.services';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.css']
})
export class ProductComponent implements OnInit {

  @ViewChild('ticketConfigurator', { static: true }) ticketConfigurator;

  constructor(
    protected bookingStepService: BookingStepService,
    private bookingOrderService: BookingOrderService,
    private router: Router,
    private shopSettingsService: ShopSettingsService,
    private navigationService: NavigationService,
  ) {
  }

  ngOnInit(): void {
    if (this.shopSettingsService.shopSettings && this.shopSettingsService.shopSettings.multiOrderMode) {
      this.bookingOrderService.singleCache.ordersCache.resetIsCacheLinesQtyCalculatedForAllChachedOders();
      this.bookingOrderService.singleCache.ordersCache.resetCacheLinesQuantity();
    }
  }

  onBackwardClick(): void {
    if (this.bookingStepService.skipBookingSlotPage) {
      this.router.navigateByUrl('');
      return;
    }
    this.bookingStepService.back();
  }

  onForwardClick(): void {
    this.bookingStepService.forward();
  }

  get forwardError(): string {

    if (this.ticketConfigurator.selectedProductTimeSpan && !this.ticketConfigurator.selectedProductTimeSpan.isCapacityAvailable) {
      return this.ticketConfigurator.selectedProductTimeSpan.footer;
    }

    return this.bookingOrderService.singleCache.invalidReason;
  }

  get showTimeSlotSimpleList(): boolean {
    return this.bookingStepService.skipBookingSlotPage;
  }

  get hideBack(): boolean {
    return this.shopSettingsService?.shopSettings?.skipSingleAreaItemPackSelection &&
      ((this.navigationService.onlyBooking && this.bookingOrderService.visibleAreaItemPacks.length === 1)
        || (this.navigationService.onlyBookingGroups && this.bookingOrderService.bookingGroupNames.length === 1));
  }
}
